<ng-container *ngIf="loading ; else  forms">
    <app-shimmer-loader [pagination]="false" type="formsShimmer">
    </app-shimmer-loader>
</ng-container>
<ng-template #forms>
    <ng-container *ngIf="data; else noData">

        <h3 *ngIf="data.pageName">{{ data.pageName }}</h3>

        <!-- Address & Email grouped to respect legacy layout (.sec1) -->
        <div class="sec1">
            <div class="address" *ngFor="let addrBlock of addressBlocks">
                <ng-container *ngFor="let item of addrBlock.data">
                    <h5>{{ item.header }}</h5>
                    <ng-container *ngFor="let para of item.paragraph">
                        <p>{{ para }}</p>
                    </ng-container>
                </ng-container>
            </div>
            <div class="email" *ngFor="let emailBlock of emailBlocks">
                <ng-container *ngFor="let item of emailBlock.data">
                    <h5>{{ item.header }}</h5>
                    <ng-container *ngFor="let para of item.paragraph">
                        <p><a [href]="'mailto:' + para">{{ para }}</a></p>
                    </ng-container>
                </ng-container>
            </div>
        </div>

        <!-- Telephone heading -->
        <ng-container *ngFor="let telHeader of telephoneHeaderBlocks">
            <ng-container *ngFor="let item of telHeader.data">
                <h5>{{ item.header }}</h5>
            </ng-container>
        </ng-container>

        <!-- Contacts list blocks combined into legacy .contacts layout -->
        <div class="contacts">
            <ng-container *ngFor="let listBlock of listBlocks">
                <ng-container *ngFor="let list of listBlock.data">
                    <div class="contact">
                        <h5>{{ list.header }}</h5>
                        <div class="numbers">
                            <p *ngFor="let item of list.items">{{ item }}</p>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>
    <ng-template #noData class="no-data">
        <app-data-unavailable [content]="'Unable to load Contact information.'"></app-data-unavailable>
    </ng-template>
</ng-template>